var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.87 0H2.13C0.953634 0 0 0.953634 0 2.13V37.87C0 39.0464 0.953634 40 2.13 40H48.87C50.0464 40 51 39.0464 51 37.87V2.13C51 0.953634 50.0464 0 48.87 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.87 0.5H2.13C1.22978 0.5 0.5 1.22978 0.5 2.13V37.87C0.5 38.7702 1.22978 39.5 2.13 39.5H48.87C49.7702 39.5 50.5 38.7702 50.5 37.87V2.13C50.5 1.22978 49.7702 0.5 48.87 0.5Z",
    stroke: "#9DADBC",
    strokeOpacity: 0.36,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7H38.4V33.4H12V7Z",
    fill: "#2F6EB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6067 29.22V19.76H38.4V22.4L36.4933 24.4534L38.4 26.58V29.22H35.32L33.6333 27.3867L32.02 29.22H21.6067Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7067 28.1933V20.7867H28.94V22.4733H24.76V23.6467H28.8667V25.3333H24.76V26.4333H28.94V28.1933H22.7067Z",
    fill: "#2F6EB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.94 28.1933L32.3867 24.4533L28.94 20.7867H31.58L33.7067 23.1333L35.8333 20.7867H38.4V20.86L35.0267 24.4533L38.4 28.0467V28.1933H35.8333L33.7067 25.7733L31.5067 28.1933H28.94Z",
    fill: "#2F6EB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.34 11.3267H26.4467L27.84 14.5534V11.3267H32.9L33.7067 13.7467L34.5867 11.3267H38.4V20.7867H18.16L22.34 11.3267Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1467 12.3533L19.8467 19.76H22.12L22.7067 18.2933H26.08L26.6667 19.76H28.94L25.7134 12.3533H23.1467ZM23.44 16.6067L24.3934 14.26L25.3467 16.6067H23.44Z",
    fill: "#2F6EB7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.94 19.76V12.3533H32.0933L33.78 16.9L35.3933 12.3533H38.4V19.76H36.4933V14.7L34.5867 19.76H32.8267L30.92 14.7V19.76H28.94Z",
    fill: "#2F6EB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.877a803efd0b1507f9f74ba07ac3376f.svg";
export { ForwardRef as ReactComponent };